export const Dot = ({ color }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M18 23L13 18L18 13L23 18L18 23Z"
        stroke={color ?? "#E54D2E"}
        strokeWidth="16"
        strokeLinecap="square"
      />
    </svg>
  );
};
